import { BackOfficeCommentsTable } from "../BackOfficeCommentsTable";
import { BackOfficeStopDetails } from "../BackOfficeStopDetails";
import { GLDistributionTable } from "../GLDistributionTable";
import { TriumphPayTxDetail } from "../TriumphPayTxDetail";
import { Button, Checkbox, DataHeader, DataSource, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlement extends Layout {
    buttonCancelTriumphpayPayment: Button;
    buttonOrderHistory: Button;
    buttonReadyToSubmit: Button;
    buttonResponsibility: Button;
    buttonTriumphPayLink: Button;
    checkboxAllocated: Checkbox;
    checkboxIsVoid: Checkbox;
    checkboxLoaded: Checkbox;
    checkboxLoadedHistory: Checkbox;
    dataheaderSettlement: DataHeader;
    layoutBackOfficeCommentsTable: BackOfficeCommentsTable;
    layoutGLDistribution: GLDistributionTable;
    layoutImageTable: Layout;
    layoutStop: BackOfficeStopDetails;
    layoutTriumphPayTxDetail: TriumphPayTxDetail;
    panelEntryInfo: Panel;
    panelMovementId: Panel;
    panelOriginDestinationInfo: Panel;
    panelPayDistance: Panel;
    panelPayTotals: Panel;
    panelPaymentDetails: Panel;
    panelProRatedPay: Panel;
    panelSettlementDates: Panel;
    panelSettlementStatus: Panel;
    sourceComments: DataSource;
    sourceDrsPendingDeduct: DataSource;
    sourceInterfaceCodeLookup: DataSource;
    sourceJournalDriver: DataSource;
    sourceResponsibleHist: DataSource;
    sourceSettlement: DataSource;
    sourceStop: DataSource;
    tabComments: Tab;
    tabGLDistribution: Tab;
    tabImages: Tab;
    tabPayAdjustments: Tab;
    tabPaymentDetails: Tab;
    tabSettlementDetails: Tab;
    tabStopDetails: Tab;
    tabTriumphPay: Tab;
    tableDeductions: Table;
    tabsetSettlement: Tabset;
    textboxAccrualDate: Textbox;
    textboxBillOfLadingNo: Textbox;
    textboxBilledDistance: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxCommodityId: Textbox;
    textboxCurrency: Textbox;
    textboxDeliveryDate: Textbox;
    textboxDestinationCity: Textbox;
    textboxDestinationState: Textbox;
    textboxDriverId: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEntryMethod: Textbox;
    textboxExternalInvoiceno: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxLinehaulCharge: Textbox;
    textboxMovementId: Textbox;
    textboxOk2payDate: Textbox;
    textboxOrderId: Textbox;
    textboxOrderTotDist: Textbox;
    textboxOrigPostedPay: Textbox;
    textboxOriginCity: Textbox;
    textboxOriginState: Textbox;
    textboxPayAdjustments: Textbox;
    textboxPayDistance: Textbox;
    textboxPayMethod: Textbox;
    textboxPayRate: Textbox;
    textboxPayUnits: Textbox;
    textboxPayeeId: Textbox;
    textboxPayeeType: Textbox;
    textboxPerDiemRate: Textbox;
    textboxPerdiemPay: Textbox;
    textboxPreloadCharge: Textbox;
    textboxProcessStatus: Textbox;
    textboxProratedRevenue: Textbox;
    textboxReadyToPayFlag: Textbox;
    textboxReasonCode: Textbox;
    textboxReasonCodeComment: Textbox;
    textboxRevenueId: Textbox;
    textboxSettlementPay: Textbox;
    textboxShipDate: Textbox;
    textboxTotalPay: Textbox;
    textboxTractorId: Textbox;
    textboxTrailerId: Textbox;
    textboxTrailerRent: Textbox;
    textboxTrailerRentPct: Textbox;
    textboxTransferDate: Textbox;
    textboxTripNumber: Textbox;
    textboxVoidDate: Textbox;
    textboxWeight: Textbox;
}
